<script setup lang="ts">

import type NewsItem from "@/types/NewsItem.ts";
import { computed } from 'vue'
import NewsItemBaseStructure from '@/components/Sections/News/Types/Base/NewsItemBaseStructure.vue'
import NewsItemBase from '@/components/Sections/News/Types/Base/NewsItemBase.vue'
import { CDN } from '@/models/cdn.ts'
import NamedNumbers from '@/components/Elements/Generic/NamedNumbers.vue'

const props = defineProps<{
  newsItem: NewsItem,
  toast: boolean
}>();

const formatPopulation = computed(() => {
  return parseInt(props.newsItem.contentData.population).toLocaleString()
})

</script>

<template>
  <NewsItemBase
    :toast="toast"
    :toast-image="CDN.technology(64, 'ringworlds')"
    :toast-text="'Ringworld ' + props.newsItem.contentData.ringworldName + ' has been completed!'"
  >
      <NewsItemBaseStructure
        :newsItem="props.newsItem"
        :item-image="CDN.technology(512, 'ringworlds')"
        :header="'Ringworld ' + props.newsItem.contentData.ringworldName + ' completed at ' + props.newsItem.contentData.starName + '!'"
      >
        <div class="flex flex-col justify-between h-full">
          <div class="flex-grow">The massive ringworld <strong>{{ props.newsItem.contentData.ringworldName }}</strong> has been completed around the star {{ props.newsItem.contentData.starName }}! This incredible feat of engineering represents the pinnacle of galactic construction capabilities.</div>
          <div class="flex justify-end pt-2">
            <NamedNumbers text="Population">
              <span class="text-green-500">{{ formatPopulation }}</span>
            </NamedNumbers>
          </div>
        </div>
      </NewsItemBaseStructure>
  </NewsItemBase>
</template>

<style scoped lang="scss">

</style>